import { NoAccess } from "components/Can/components";
import { useUserRoleACLs } from "hooks";

import type { ACL } from "models";
import type { ReactNode } from "react";

type RoleACLs = {
  [key: string]: ACL[];
};

type CanProps = {
  I: string | string[];
  children: ReactNode;
  the: string | string[];
  a?: string;
  renderNoAccess?: boolean;
};

export const checkPermissions = (roleACLs: RoleACLs | null | undefined, resource: CanProps["the"], activity: CanProps["I"]): boolean => {
  if (!roleACLs || !resource.length || !activity.length) return false;

  if (Array.isArray(resource) && Array.isArray(activity)) {
    return resource.some(resource => Boolean(roleACLs[resource]) && roleACLs[resource].some(roleACL => activity.includes(roleACL.activity)));
  } else if (Array.isArray(resource)) {
    return resource.some(resource => Boolean(roleACLs[resource]) && roleACLs[resource].some(roleACL => activity === roleACL.activity));
  } else if (Array.isArray(activity)) {
    return Boolean(roleACLs[resource]) && roleACLs[resource].some(roleACL => activity.includes(roleACL.activity));
  }

  return Boolean(roleACLs[resource]) && roleACLs[resource].some(roleACL => activity === roleACL.activity);
};

export const Can = ({ I, a, the, renderNoAccess, children }: CanProps) => {
  const roleACLs = useUserRoleACLs();
  const resource = the || a || "";

  if (!roleACLs) return null;

  if (checkPermissions(roleACLs, resource, I)) return children;

  return renderNoAccess ? <NoAccess /> : null;
};

export const useCan = (activity: CanProps["I"], resources: CanProps["the"]) => {
  const roleACLs = useUserRoleACLs();

  if (!roleACLs) return false;

  return checkPermissions(roleACLs, resources, activity);
};
